/* eslint-env jquery */
export default () => {
	var showAll = false; // Initialize the showAll state
	function loadPage(page, filterValue, sortOrder) {
		jQuery.ajax({
			url: '/wp-json/gsfc/v2/job-feed',
			type: 'POST',
			data: {
				action: 'get_csv_data',
				page: showAll ? 1 : page, // If showAll is true, always load the first page
				content: filterValue,
				show_all: showAll, // Pass the showAll flag to the server
				sort_order: sortOrder, // Pass the sort order to the server
			},
			success: function (response) {
				var jobList = jQuery('.jobs-feed ul');
				var paginationContainers = document.querySelectorAll(
					'.js-gsfc-feed-pagination'
				);

				if (response.success) {
					var data = response.data.data;
					var currentPage = response.data.current_page;
					var totalPages = response.data.total_pages;

					// Update the job list
					jobList.empty();
					jQuery.each(data, function (index, row) {
						var listItem = '<li title="' + row[1] + '">';
						listItem +=
							'<h3 class="govuk-heading-m pt-2"><a href="' +
							row[9] +
							'" target="_blank">' +
							row[1] +
							'</a>';
						if (
							row[8] === 'Across government' ||
							row[8] === 'Internal'
						) {
							listItem +=
								'<p class="govuk-hint">(Requires login)</p>';
						}
						listItem += '</h3>';
						listItem +=
							'<p class="department">Department: ' +
							row[2] +
							'</p>';
						listItem += '<p>Grade: ' + row[3] + '</p>';
						listItem += '<p>Closing date: ' + row[4] + '</p>';
						listItem += '</li>';
						jobList.append(listItem);
					});

					// Update the pagination controls
					if (!showAll) {
						var html = `<nav class="govuk-pagination mx-auto" role="navigation" aria-label="Pagination"><ul class="govuk-pagination__list">`;
						var skipLink = false;

						if (currentPage > 1) {
							html += `<div class="govuk-pagination__prev">
                            <a class="govuk-link govuk-pagination__link js-gsfc-filter-pagination prev" href="#" rel="prev" data-page="${
								currentPage - 1
							}">
                            <svg class="govuk-pagination__icon govuk-pagination__icon--prev" xmlns="http://www.w3.org/2000/svg" height="13" width="15" aria-hidden="true" focusable="false" viewBox="0 0 15 13">
                                <path d="m6.5938-0.0078125-6.7266 6.7266 6.7441 6.4062 1.377-1.449-4.1856-3.9768h12.896v-2h-12.984l4.2931-4.293-1.414-1.414z"></path>
                            </svg>
                            <span class="govuk-pagination__link-title">
                                Previous<span class="govuk-visually-hidden"> page</span>
                            </span>
                            </a>
                        </div>`;
						}

						for (var i = 1; i <= totalPages; i++) {
							var active =
								i === currentPage
									? ' govuk-pagination__item--current'
									: '';

							// Truncate page links for large number of results, display ellipses the first time links are skipped
							if (
								i === 1 ||
								i === currentPage - 1 ||
								i === currentPage ||
								i === currentPage + 1 ||
								i === totalPages
							) {
								html += `<li class="govuk-pagination__item${active}"><a href="#" class="govuk-link govuk-pagination__link js-gsfc-filter-pagination" data-page="${i}">${i}</a></li>`;
								skipLink = true;
							} else if (skipLink) {
								html += `<li class="govuk-pagination__item">...</li>`;
								skipLink = false;
							}
						}

						html += `</ul>`;

						if (currentPage < totalPages) {
							html += `<div class="govuk-pagination__next">
                                <a class="govuk-link govuk-pagination__link js-gsfc-filter-pagination next" href="#" rel="next" data-page="${currentPage + 1}">
                                    <span class="govuk-pagination__link-title">
                                        Next<span class="govuk-visually-hidden"> page</span>
                                    </span>
                                    <svg class="govuk-pagination__icon govuk-pagination__icon--next" xmlns="http://www.w3.org/2000/svg" height="13" width="15" aria-hidden="true" focusable="false" viewBox="0 0 15 13">
                                        <path d="m8.107-0.0078125-1.4136 1.414 4.2926 4.293h-12.986v2h12.896l-4.1855 3.9766 1.377 1.4492 6.7441-6.4062-6.7246-6.7266z"></path>
                                    </svg>
                                </a>
                            </div>`;
						}

						html += `</nav>
                            <div class="show-all-container">
                                <a href="#" class="js-gsfc-show-all">Show All</a>
                            </div>`;
						paginationContainers.forEach(function (container) {
							container.innerHTML = html;
						});
					} else {
						paginationContainers.forEach(function (container) {
							container.innerHTML = `<div class="show-all-container">
                                <a href="#" class="js-gsfc-show-less">Show Less</a>
                            </div>`;
						});
					}
				} else {
					console.error('Error:', response.data); // Log the error to the console
					jobList.empty();
					jobList.append('<li>No items found.</li>'); // Display a message when no items are found
					paginationContainers.forEach(function (container) {
						container.innerHTML = '';
					});
				}
			},
			error: function (xhr, status, error) {
				console.error('AJAX Error:', error); // Log AJAX errors to the console
			},
		});
	}
	// Initial load
	var filterValue = jQuery('.jobs-feed').data('filter'); // Get the filter value from the data-filter attribute
	var sortOrder = jQuery('#sort-order').val(); // Get the initial sort order
	loadPage(1, filterValue, sortOrder);

	// Handle pagination click
	jQuery(document).on('click', '.js-gsfc-filter-pagination', function (e) {
		e.preventDefault();
		showAll = false; // Reset the showAll state
		var page = jQuery(this).data('page');
		loadPage(page, filterValue, sortOrder);
	});

	// Handle sort order change
	jQuery('#sort-order').on('change', function () {
		sortOrder = jQuery(this).val();
		loadPage(1, filterValue, sortOrder);
	});

	// Handle Show All click
	jQuery(document).on('click', '.js-gsfc-show-all', function (e) {
		e.preventDefault();
		showAll = true; // Set the showAll state to true
		loadPage(1, filterValue, sortOrder);
	});

	// Handle Show Less click
	jQuery(document).on('click', '.js-gsfc-show-less', function (e) {
		e.preventDefault();
		showAll = false; // Set the showAll state to false
		loadPage(1, filterValue, sortOrder);
	});
};
